import SubCategoryManage from "./create-shift-sub-category";

export default SubCategoryManage;
